import PropTypes from 'prop-types';
import React, { Component, PureComponent } from 'react';
import shallowEqual from 'fbjs/lib/shallowEqual';
import { connect } from 'react-redux';
import _ from 'lodash';
import Paper from 'material-ui/Paper';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import {Tabs, Tab} from 'material-ui/Tabs';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import SvgIcon from 'material-ui/SvgIcon';
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
import * as Colors from 'material-ui/styles/colors';
import DebounceInput from 'react-debounce-input';
import {Scrollbars} from 'shared/vendor/react-custom-scrollbars/src/index';
import BaseDialog, {TITLE_THEME_DARK} from 'shared/components/Dialogs/BaseDialog/BaseDialog';
import {getSuggestedCategories, getBrowseCategories} from 'MyAccount/Listings/listingsHelper';
import SearchField from 'shared/components/SearchField/SearchField';
import InlineButton from 'shared/components/InlineButton';
import PoppingTextElement from 'shared/components/PoppingTextElement';
import EllipsisTooltipText from 'shared/components/EllipsisTooltipText';
import {getUpdatedEbayListingValues} from './ebayListingSelectors';
import {TweenLite} from 'gsap';
import {arrowRightThick} from 'shared/icons/index';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import {FIELD_NAMES} from './consts';
import connectWithRouter from 'shared/components/redux/connectWithRouter';
/* global Strong Linear SlowMo Ease TimelineMax */

const BROWSE_CATEGORIES_LEVEL_ID_PREFIX = 'browse-categories-level-';
const RECENTLY_USED_CATEGORIES_TAB_ID = 'RECENTLY USED CATEGORIES';
const SUGGESTED_CATEGORIES_TAB_ID = 'SUGGESTED CATEGORIES';
const SEARCH_CATEGORIES_TAB_ID = 'SEARCH CATEGORIES';
const BROWSE_CATEGORIES_TAB_ID = 'BROWSE CATEGORIES';
const TABS = [RECENTLY_USED_CATEGORIES_TAB_ID, SUGGESTED_CATEGORIES_TAB_ID, SEARCH_CATEGORIES_TAB_ID, BROWSE_CATEGORIES_TAB_ID];

const DIALOG_CONTENT_HEIGHT = '100vh - 350px';
const TABS_HEIGHT = 48;
const TABS_WIDTH = 890;
const TAB_CONTENT_MARGIN = 20;
const BROWSE_CATEGORIES_MENU_WIDTH = 300;
const BROWSE_CATEGORIES_SPACE_BETWEEN = 40;
const BROWSE_CATEGORIES_LEVEL_PAPER_WIDTH = BROWSE_CATEGORIES_MENU_WIDTH + BROWSE_CATEGORIES_SPACE_BETWEEN;
const BROWSE_CATEGORIES_ANIMATION_MOVE_BY = BROWSE_CATEGORIES_SPACE_BETWEEN;
const BROWSE_CATEGORIES_ENTER_ANIMATION_DURATION = 0.4;
const BROWSE_CATEGORIES_EXIT_ANIMATION_DURATION = 0.4;
const BROWSE_CATEGORIES_FIRST_LEVEL = 1;

const LIST_ITEM_STYLE = {
  marginLeft: 10,
  marginTop: 10,
  display: 'list-item',
};

function getInitialState(props) {
  const {initialCategoryId} = props;
  return ({
    selectedCategoryId: initialCategoryId,
    selectedTabId: RECENTLY_USED_CATEGORIES_TAB_ID,
    searchCategories: null,
    searchText: null,
    browseCategories: null,
    currentBrowseCategoryId: null,
    currentBrowseCategoryIDPath: null,
    waitingForGetBrowseCategoriesRequest: false,
    waitingForFirstAnimationPartToEnd: false,
  });
}

@connectWithRouter(
  (state) => ({
    site: _.get(getUpdatedEbayListingValues(state), FIELD_NAMES.EBAY_SITE),
    recentlyUsedCategories: state.ebayListing.recentlyUsedCategories,
  })
)
export default class CategorySelectorDialog extends Component {

  state = getInitialState(this.props);

  componentWillMount() {
    const {initialCategoryId} = this.props;
    this.getBrowseCategories(initialCategoryId);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.initialCategoryId !== nextProps.initialCategoryId) {
      this.setState({selectedCategoryId: nextProps.initialCategoryId});
    }
  }

  shouldComponentUpdate() {
    const {waitingForFirstAnimationPartToEnd} = this.state;
    if (this.animation && waitingForFirstAnimationPartToEnd) {
      setTimeout(() => {
        this.animation = null;
        this.setState({waitingForFirstAnimationPartToEnd: false});
      }, (this.animation.duration() - this.animation.time()) * 1000);
      return false;
    }
    return true;
  }

  componentDidUpdate(prevProps, prevState) {
    const {browseCategories, waitingForGetBrowseCategoriesRequest, waitingForFirstAnimationPartToEnd} = this.state;
    const newBrowseCategoriesLevelId = `#${BROWSE_CATEGORIES_LEVEL_ID_PREFIX}${_.size(browseCategories)}`;
    if ((prevState.waitingForGetBrowseCategoriesRequest || prevState.waitingForFirstAnimationPartToEnd) && !waitingForGetBrowseCategoriesRequest && !waitingForFirstAnimationPartToEnd) {
      _.defer(() => {
        TweenLite.to(newBrowseCategoriesLevelId, BROWSE_CATEGORIES_ENTER_ANIMATION_DURATION, {x: 0, opacity: 1, ease: Ease.easeOut});
        const scrollbarElement = _.get(this.mainScrollbars, 'refs.view');
        if (scrollbarElement) {
          TweenLite.to(scrollbarElement, BROWSE_CATEGORIES_ENTER_ANIMATION_DURATION, {scrollTo: {x: 'max'}, ease: Ease.easeOut});
        }
      });
    }
  }

  getBrowseCategories = (categoryId, isLeaf = true, categoryLevel = 1, async = true) => {
    const {site} = this.props;
    const {browseCategories, currentBrowseCategoryIDPath} = this.state;
    const browseCategoriesSize = _.size(browseCategories);
    const lastLevelClicked = categoryLevel === browseCategoriesSize;
    let startTwoPartAnimation = false;
    let updatedState = {currentBrowseCategoryId: categoryId};
    if (isLeaf) {
      updatedState = _.merge({}, updatedState, {selectedCategoryId: categoryId});
    } else {
      updatedState = _.merge({}, updatedState, {selectedCategoryId: ''});
    }
    if (!lastLevelClicked) {
      _.forEach(browseCategories, (level, levelNumber) => {
        if (levelNumber > categoryLevel) {
          const levelId = `#${BROWSE_CATEGORIES_LEVEL_ID_PREFIX}${levelNumber}`;
          this.animation = TweenLite.to(levelId, BROWSE_CATEGORIES_EXIT_ANIMATION_DURATION, {x: -BROWSE_CATEGORIES_ANIMATION_MOVE_BY, opacity: 0, ease: Ease.easeIn});
          if (!startTwoPartAnimation) {
            startTwoPartAnimation = true;
            updatedState = _.merge({}, updatedState, {waitingForFirstAnimationPartToEnd: true});
          }
        }
      });
      const scrollbarElement = _.get(this.mainScrollbars, 'refs.view');
      if (scrollbarElement) {
        const newScrollWidth = isLeaf ? BROWSE_CATEGORIES_LEVEL_PAPER_WIDTH * categoryLevel : BROWSE_CATEGORIES_LEVEL_PAPER_WIDTH * (categoryLevel + 1);
        const scrollTo = newScrollWidth > scrollbarElement.offsetWidth ? newScrollWidth - scrollbarElement.offsetWidth : 0;
        TweenLite.to(scrollbarElement, BROWSE_CATEGORIES_EXIT_ANIMATION_DURATION, {scrollTo: {x: scrollTo}, ease: Ease.easeOut});
      }
    }
    if (!isLeaf || !lastLevelClicked) {
      const newCategoryIDPath = _.filter(currentBrowseCategoryIDPath, (name, index) => index + 1 < categoryLevel);
      newCategoryIDPath.push(categoryId);
      updatedState = {...updatedState, waitingForGetBrowseCategoriesRequest: true, currentBrowseCategoryIDPath: newCategoryIDPath};
    }
    this.setState(updatedState);
    getBrowseCategories(categoryId, site, async).then(result => {
      const {waitingForFirstAnimationPartToEnd} = this.state;
      if (result.success) {
        this.setState({
          browseCategories: result.data,
          currentBrowseCategoryIDPath: result.selectedCategory.CategoryIDPath,
          waitingForGetBrowseCategoriesRequest: false,
        });
        if (!isLeaf && !waitingForFirstAnimationPartToEnd) {
          TweenLite.set(`#${BROWSE_CATEGORIES_LEVEL_ID_PREFIX}${_.size(result.data)}`, {x: -BROWSE_CATEGORIES_ANIMATION_MOVE_BY, opacity: 0});
        }
      }
    });
  };

  setMainScrollbars = (ref) => {
    if (ref) {
      this.mainScrollbars = ref;
    }
  };

  handleClose = () => {
    const {handleClose} = this.props;
    handleClose();
  };

  handleSubmit = (categoryId) => {
    const {handleClose} = this.props;
    handleClose(categoryId);
  };

  handleTabChange = (tabId) => {
    this.setState({selectedTabId: tabId});
  };

  searchCategories = (searchText) => {
    const {site} = this.props;
    this.setState({searchCategories: null});
    getSuggestedCategories(searchText, site, false).then(result => {
      if (result.success) {
        this.setState({searchCategories: result.data, searchText});
      }
    });
  };

  contactSupport = () => {
    window.Intercom('showNewMessage',
      'Hello Crazylister\n' +
      'I have a question regarding selecting an eBay category when editing a listing');
  };

  renderContactSupportListItem = () => {
    return (
      <div style={LIST_ITEM_STYLE}>
        <InlineButton onClick={this.contactSupport}>
          Write to our customer service
        </InlineButton>
        &nbsp;if you need help.
      </div>
    );
  };

  renderSearchResults = () => {
    const {searchCategories, searchText} = this.state;
    if (searchCategories !== null) {
      if (_.isEmpty(searchCategories)) {
        return (
          <div style={{marginTop: 20}}>
            <div>Your search "<span style={{fontWeight: 600}}>{searchText}</span>" did not match any categories</div>
            <div style={LIST_ITEM_STYLE}>
              Double check your spelling
            </div>
            <div style={LIST_ITEM_STYLE}>
              Try using single words
            </div>
            <div style={LIST_ITEM_STYLE}>
              Try searching for a category that is less specific
            </div>
            {this.renderContactSupportListItem()}
          </div>
        );
      }
      return (
        <div>
          Select a category from these search results:
          {this.renderCategoriesRadioButtons(searchCategories)}
        </div>
      );
    }
    return null;
  };

  renderEmptyStateTab = (mainMessage) => {
    return (
      <div>
        {mainMessage}
        <div style={LIST_ITEM_STYLE}>
          Try&nbsp;
          <InlineButton onClick={() => this.handleTabChange(SEARCH_CATEGORIES_TAB_ID)}>
            searching
          </InlineButton>
          &nbsp;or&nbsp;
          <InlineButton onClick={() => this.handleTabChange(BROWSE_CATEGORIES_TAB_ID)}>
            browsing
          </InlineButton>
          &nbsp;for a category.
        </div>
        {this.renderContactSupportListItem()}
      </div>
    );
  };

  renderTabs = () => {
    const {selectedTabId} = this.state;
    const tabs = [];
    _.forEach(TABS, (tabId) => {
      const color = tabId === selectedTabId ? Colors.grey700 : Colors.grey500;
      tabs.push(
        <Tab
          key={tabId}
          label={tabId}
          style={{color: color}}
          value={tabId}
          onActive={() => this.handleTabChange(tabId)}
        />);
    });
    return tabs;
  };

  renderSelectedTabContent = () => {
    const {selectedTabId} = this.state;
    switch (selectedTabId) {
      case RECENTLY_USED_CATEGORIES_TAB_ID:
        const {recentlyUsedCategories} = this.props;
        if (_.isEmpty(recentlyUsedCategories)) {
          return this.renderEmptyStateTab('There are no recently used categories yet.');
        }
        return (
          <div>
            Select one of the recently used categories:
            {this.renderCategoriesRadioButtons(recentlyUsedCategories)}
          </div>
        );
      case SUGGESTED_CATEGORIES_TAB_ID:
        const {suggestedCategories} = this.props;
        if (_.isEmpty(suggestedCategories)) {
          return this.renderEmptyStateTab("We don't have enough data to suggest a category.");
        }
        return (
          <div>
            Select one of the suggested categories:
            {this.renderCategoriesRadioButtons(suggestedCategories)}
          </div>
        );
      case SEARCH_CATEGORIES_TAB_ID:
        return (
          <div>
            <div style={{display: 'flex', justifyContent: 'center'}}>
              <SearchField
                hintText="Search for categories using keywords"
                onEnterDown={this.searchCategories}
              />
            </div>
            <div style={{marginTop: 20}}>
              {this.renderSearchResults()}
            </div>
          </div>
        );
      case BROWSE_CATEGORIES_TAB_ID:
        const {browseCategories, currentBrowseCategoryId, selectedCategoryId, currentBrowseCategoryIDPath} = this.state;
        const {getBrowseCategories} = this;
        const numberOfLevels = _.size(browseCategories);
        return (
          <div style={{display: 'flex'}}>
            {_.map(browseCategories, (level, levelNumber) => {
              const categoriesLevelId = `${BROWSE_CATEGORIES_LEVEL_ID_PREFIX}${levelNumber}`;
              const browseCategoriesMenuProps = {getBrowseCategories, level, categoriesLevelId, numberOfLevels, levelNumber};
              const currentLevel = parseInt(levelNumber, 10);
              browseCategoriesMenuProps.categoryInPath = currentBrowseCategoryIDPath[currentLevel - 1];
              if (numberOfLevels === currentLevel || numberOfLevels === currentLevel + 1) {
                browseCategoriesMenuProps.currentBrowseCategoryId = currentBrowseCategoryId;
                browseCategoriesMenuProps.selectedCategoryId = selectedCategoryId;
              }
              return (<BrowseCategoriesMenuWrapper key={levelNumber} {...browseCategoriesMenuProps}/>);
            })}
          </div>
        );
      default:
        break;
    }
  };

  renderCategoriesRadioButtons = (categories) => {
    const {selectedCategoryId} = this.state;
    const categoriesRadioButtons = [];
    _.forEach(categories, (category) => {
      categoriesRadioButtons.push(
        <RadioButton
          key={category.CategoryID}
          value={category.CategoryID}
          label={<div>{`${_.join(_.dropRight(category.CategoryNamePath), ' > ')} >`}&nbsp;<span style={{fontWeight: 600}}>{category.CategoryName}</span></div>}
          style={{marginTop: 5}}
        />);
    });
    return (
      <RadioButtonGroup
        name="categoriesRadioButtons"
        valueSelected={selectedCategoryId}
        onChange={(event, value) => this.setState({selectedCategoryId: value})}
      >
        {categoriesRadioButtons}
      </RadioButtonGroup>
    );
  };

  render() {
    const {open} = this.props;
    const {selectedCategoryId, selectedTabId} = this.state;
    const actions = [
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <div style={{display: 'flex', margin: 10, alignItems: 'center'}}>
          Category number:
          <DebounceInput
            element = {PoppingTextElement}
            value={selectedCategoryId || ''}
            onChangeValue={(value) => this.setState({selectedCategoryId: value})}
          />
        </div>
        <div>
          <FlatButton
            style={{marginRight: 10}}
            label="Cancel"
            onClick={this.handleClose}
          />
          <RaisedButton
            label="Submit category"
            primary
            disabled={selectedCategoryId === ''}
            onClick={() => this.handleSubmit(selectedCategoryId)}
          />
        </div>
      </div>
    ];
    return (
      <BaseDialog
        title="Choose Category"
        titleTheme={TITLE_THEME_DARK}
        contentStyle={{width: 'calc(100% - 50px)', maxWidth: 'none'}}
        bodyStyle={{padding: 0}}
        closeButtonColor={Colors.white}
        open={open}
        actions={actions}
        actionsContainerStyle={{backgroundColor: Colors.grey50}}
        onRequestClose={this.handleClose}
        autoScrollBodyContent
      >
        <div style={{height: `calc(${DIALOG_CONTENT_HEIGHT})`}}>
          <Paper style={{height: TABS_HEIGHT, backgroundColor: Colors.grey50, display: 'flex', justifyContent: 'center'}}>
            <Tabs
              style={{width: TABS_WIDTH}}
              tabItemContainerStyle={{backgroundColor: Colors.transparent}}
              value={selectedTabId}
            >
              {this.renderTabs()}
            </Tabs>
          </Paper>
          <Scrollbars ref={this.setMainScrollbars} style={{width: 'calc(100vw - 50px)', height: `calc(${DIALOG_CONTENT_HEIGHT} - ${TABS_HEIGHT}px)`, overflow: 'hidden'}}>
            <div style={{padding: TAB_CONTENT_MARGIN, display: 'inline-block', minWidth: 'calc(100vw - 90px)'}}>
              {this.renderSelectedTabContent()}
            </div>
          </Scrollbars>
        </div>
      </BaseDialog>
    );
  }
}


class BrowseCategoriesMenuWrapper extends PureComponent {
  render() {
    const {getBrowseCategories, categoriesLevelId, numberOfLevels, levelNumber, selectedCategoryId, currentBrowseCategoryId, categoryInPath, level} = this.props;
    return (<div id={categoriesLevelId} style={{display: 'flex', alignItems: 'center', zIndex: numberOfLevels - levelNumber}}>
      {parseInt(levelNumber, 10) > BROWSE_CATEGORIES_FIRST_LEVEL &&
      <div style={{width: BROWSE_CATEGORIES_SPACE_BETWEEN, display: 'flex', justifyContent: 'center'}}>
        <SvgIcon color={Colors.grey400}>
          <path d={arrowRightThick} />
        </SvgIcon>
      </div>
      }
      <Paper>
        <Scrollbars style={{width: BROWSE_CATEGORIES_MENU_WIDTH, height: `calc(${DIALOG_CONTENT_HEIGHT} - ${TABS_HEIGHT}px - ${TAB_CONTENT_MARGIN * 2}px)`, overflowY: 'hidden'}}>
          <BrowseCategoriesMenu {...{getBrowseCategories, selectedCategoryId, currentBrowseCategoryId, categoryInPath, level}}/>
        </Scrollbars>
      </Paper>
    </div>);
  }
}

class BrowseCategoriesMenu extends Component {
  shouldComponentUpdate(nextProps) {
    return (!!nextProps.currentBrowseCategoryId) || !shallowEqual(_.omit(nextProps, 'level'), _.omit(this.props, 'level')); // level will always change since its new object from ajax
  }

  render() {
    const {getBrowseCategories, selectedCategoryId, currentBrowseCategoryId, categoryInPath, level} = this.props;
    return (<Menu disableAutoFocus autoWidth={false} width={BROWSE_CATEGORIES_MENU_WIDTH}>
      {_.map(_.sortBy(level, 'CategoryName'), (category) => {
        let color;
        let backgroundColor;
        let disabled;
        if (category.CategoryID === selectedCategoryId && selectedCategoryId === currentBrowseCategoryId) {
          color = Colors.white;
          backgroundColor = Colors.lightGreen500;
        } else if (categoryInPath === category.CategoryID) {
          backgroundColor = Colors.grey300;
        }
        if (selectedCategoryId === category.CategoryID || !selectedCategoryId && currentBrowseCategoryId === category.CategoryID) {
          disabled = true;
        }
        return (<BrowseCategoriesMenuItem key={category.CategoryID} category={category} disabled={disabled} getBrowseCategories={getBrowseCategories} color={color} backgroundColor={backgroundColor}/>);
      })}
    </Menu>);
  }
}

class BrowseCategoriesMenuItem extends PureComponent {
  onClick = () => {
    const {category, getBrowseCategories} = this.props;
    return getBrowseCategories(category.CategoryID, category.LeafCategory, category.CategoryLevel, false);
  };

  renderBrowseCategoriesMenuItemText = (categoryName) => {
    const {disabled} = this.props;
    return (
      <EllipsisTooltipText
        text={categoryName}
        anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
        targetOrigin={{horizontal: 'right', vertical: 'top'}}
        onClick = {disabled ? undefined : this.onClick}
      />
    );
  };

  render() {
    const {category, color, backgroundColor, disabled} = this.props;
    const menuItemStyle = _.pickBy({color, backgroundColor});
    return (
      <MenuItem
        style={{width: BROWSE_CATEGORIES_MENU_WIDTH, zIndex: 0, ...menuItemStyle}}
        primaryText={this.renderBrowseCategoriesMenuItemText(category.CategoryName)}
        rightIcon={category.LeafCategory ? undefined : <ArrowDropRight/>}
        onClick={disabled ? undefined : this.onClick}/>
    );
  }
}